module.exports = __webpack_public_path__ + "static/media/YB5F17_6.1e116f9b.jpg";